"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.tinygo = exports.rust = exports.go = exports.assemblyscript = void 0;
const tslib_1 = require("tslib");
// Expose `widl.codegen.assemblyscript` for the browser
const assemblyscriptAll = tslib_1.__importStar(require("./assemblyscript"));
exports.assemblyscript = assemblyscriptAll;
// Expose `widl.codegen.go` for the browser
const goAll = tslib_1.__importStar(require("./go"));
exports.go = goAll;
// Expose `widl.codegen.rust` for the browser
const rustAll = tslib_1.__importStar(require("./rust"));
exports.rust = rustAll;
// Expose `widl.codegen.tinygo` for the browser
const tinygoAll = tslib_1.__importStar(require("./tinygo"));
exports.tinygo = tinygoAll;
// Expose `widl.codegen.utils` for the browser
const utilsAll = tslib_1.__importStar(require("./utils"));
exports.utils = utilsAll;
//# sourceMappingURL=index.js.map